/**
 * Airdrop Modal Content
 * Detailed view of airdrop eligibility and criteria (rendered inside Modal component)
 */

import React, { useEffect } from 'react';
import { useAirdrop } from '../../contexts/AirdropContext';
import './AirdropModal.css';

export function AirdropModalContent() {
  const { 
    currentRound, 
    userEligibility, 
    loading,
    refreshEligibility,
    connectTwitter
  } = useAirdrop();
  
  /**
   * Refresh eligibility when component mounts
   */
  useEffect(() => {
    refreshEligibility();
  }, [refreshEligibility]);
  
  if (!currentRound) return <div className="airdrop-loading">No active airdrop round</div>;
  
  // Parse eligibility criteria from config
  // TODO: These should come from the backend/config
  const minBets = 1;
  
  const userBets = userEligibility?.betCount || 0;
  const hasSocial = userEligibility?.hasSocialConnected || false;
  const userVolume = userEligibility?.totalVolume || 0;
  const totalEligibleVolume = userEligibility?.totalEligibleVolume || 0;
  const totalPool = currentRound?.totalPool || 0;
  
  const betsComplete = userBets >= minBets;
  const socialComplete = hasSocial;
  
  const isEligible = userEligibility?.isEligible || false;
  
  // Calculate estimated reward on frontend (more accurate!)
  let estimatedReward = 0;
  if (isEligible && totalPool > 0 && totalEligibleVolume > 0 && userVolume > 0) {
    // Proportional distribution: user's share = (user volume / total eligible volume) * pool
    estimatedReward = (userVolume / totalEligibleVolume) * totalPool;
  } else if (isEligible && totalPool > 0 && totalEligibleVolume === 0) {
    // First eligible user gets entire pool
    estimatedReward = totalPool;
  }
  
  return (
    <div className="airdrop-modal-inner">
          {/* How It Works */}
          <div className="airdrop-how-it-works">
            <p>Every day, active bettors share a portion of the platform's earnings proportional to their betting volume.</p>
          </div>
          
          {/* Eligibility Header */}
          <div className="airdrop-criteria-header">
            Eligibility Criteria:
          </div>
          
          {/* Eligibility Checklist */}
          {loading.eligibility ? (
            <div className="airdrop-loading">Loading...</div>
          ) : (
            <div className="airdrop-criteria-list">
              {/* Twitter Connection */}
              <div className="airdrop-criteria-row">
                <span className={`airdrop-indicator ${socialComplete ? 'complete' : 'incomplete'}`}>
                  {socialComplete ? '✓' : '○'}
                </span>
                <span className="airdrop-criteria-text">Twitter connected</span>
                {socialComplete ? (null) : (
                  <button 
                    className="airdrop-action-btn connect"
                    onClick={connectTwitter}
                    disabled={loading.twitter}
                  >
                    Connect
                  </button>
                )}
              </div>
              
              {/* Minimum Bets */}
              <div className="airdrop-criteria-row">
                <span className={`airdrop-indicator ${betsComplete ? 'complete' : 'incomplete'}`}>
                  {betsComplete ? '✓' : '○'}
                </span>
                <span className="airdrop-criteria-text">
                  {userBets}/{minBets} bets
                </span>
              </div>
            </div>
          )}
          
          {/* Status */}
          {isEligible && (
            <div className="airdrop-eligible-badge">
              <div className="airdrop-eligible-main">
                ✓ You're eligible for this round
              </div>
              {estimatedReward > 0 && (
                <div className="airdrop-eligible-subtext">
                  Estimated reward: ~{estimatedReward.toFixed(4)} SOL
                </div>
              )}
            </div>
          )}
    </div>
  );
}

export default AirdropModalContent;

